import { render } from "./FloorsPage.vue?vue&type=template&id=3fe1edd2"
import script from "./FloorsPage.vue?vue&type=script&lang=js"
export * from "./FloorsPage.vue?vue&type=script&lang=js"

import "./FloorsPage.vue?vue&type=style&index=0&id=3fe1edd2&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__